// extracted by mini-css-extract-plugin
export default {"title":"Akordion_title__A0Wa0","akordion":"Akordion_akordion__KxU0J"};